module.exports = __webpack_public_path__ + "static/media/install01.204397b3.png";